import { queryClient } from "@/query-client";
import { queryOptions, useMutation } from "@tanstack/react-query";
import type { Checklist } from "../../types/checklist";
import checklistService from "../services/checklist-service";

type ChecklistFilters = {
	search?: string;
	category?: string;
	project_id?: number;
	page?: number;
	per_page?: number;
};

export const checklistsQueryOptions = (filters: ChecklistFilters = {}) =>
	queryOptions({
		queryKey: ["checklists", filters],
		queryFn: () => checklistService.list(filters),
	});

export const checklistQueryOptions = (id: string) =>
	queryOptions({
		queryKey: ["checklist", id],
		queryFn: () => checklistService.findById(id),
		enabled: !!id,
	});

export const useChecklistCreateMutation = () =>
	useMutation({
		mutationFn: (checklist: Omit<Checklist, "id" | "created_at" | "updated_at" | "deleted_at">) => checklistService.create(checklist),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["checklists"],
			});
		},
	});

export const useChecklistUpdateMutation = (id: string) =>
	useMutation({
		mutationFn: (checklist: Partial<Checklist>) => checklistService.updateById(id, checklist),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["checklists"],
			});
			queryClient.invalidateQueries({
				queryKey: ["checklist", id],
			});
		},
	});

export const useChecklistDeleteMutation = () =>
	useMutation({
		mutationFn: (id: string) => checklistService.deleteById(id),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["checklists"],
			});
		},
	});
